export const ENTER = 13;
export const ESCAPE = 27;
export const SPACEBAR = 32;
export const LEFTARROW = 37;
export const UPARROW = 38;
export const RIGHTARROW = 39;
export const DOWNARROW = 40;
